import { useEffect, useState } from 'react';
import styled from 'styled-components';

import FetchModule from '../../Share/Network/FetchModule.js';
import { useLanguage } from '../../../Context/LanguageContext';

import CertificationLogoPath from '../../../image/CertificationLogo.png';

const CertificationView = () => {
  const { t } = useLanguage();

  const [isSuccess, setIsSuccess] = useState(false);

  // 이메일 인증 토큰 검증 //
  useEffect(() => {
    const certificationString = window.sessionStorage.getItem("CertificationString");

    const fetchModule = new FetchModule();
    (
      async () => {
        const response = await fetchModule.postData('account/asp/certification/' + certificationString, 'POST');

        if (response.status === 200) setIsSuccess(true);
        else setIsSuccess(false);
      }
    )();
  }, [])

  // 나가기 버튼 클릭시 //
  function onClickExit() {
    window.open("about:blank", "_self");
    window.close();
  }

  return (
    <TopLevelWrapper>
      <LogoWrapper>
        <Logo src={CertificationLogoPath}/>
      </LogoWrapper>
      <Banner>LINKO ZONE</Banner>
      <SemiBanner>{t('login.slogan')}</SemiBanner>
      {
        isSuccess ?
        <Explanation>{t('findAccount.certificationComplete')}</Explanation>
        :
        <Explanation>{t('findAccount.certificationInvalid')}</Explanation>
      }
      <ExitButton onClick={onClickExit}>
        <ExitText>{t('findAccount.exit')}</ExitText>
      </ExitButton>
    </TopLevelWrapper>
  )
};

export default CertificationView;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: all 0.5s ease-in-out;
`;

const LogoWrapper = styled.div`
  margin-bottom: 12px;
`;

const Logo = styled.img`
  width: 200px;
  height: 200px;
`;

const Banner = styled.p`
  font-family: Poppins-SemiBold;
  font-size: 54px;
  color: #FF8B48;

  margin: 0 0 0 0;
`;

const SemiBanner = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 24px;
  color: #151617;
  opacity: 0.7;
  margin: 0 0 0 0;
`;

const Explanation = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 24px;
  color: #000000;
  margin: 56px 0 0 0;
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  width: 591px;
  height: 79px;

  background-color: #FF8B48;
  border-radius: 25px;

  margin-top: 64px;

  &:hover {
    cursor: pointer;
    background-color: #FF7322;
  }
`;

const ExitText = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 24px;
  color: #FFFFFF;

  margin: 0 0 0 0;
`;
